import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { FaSpinner } from "react-icons/fa6";
import { useForm } from "react-hook-form";
import axios from "axios";
import Swal from "sweetalert2";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";

import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import Ticket from "./ticket";
import "./style.css";

const Quote = () => {
  const [ticketData, setTicketData] = useState({});
  const [showTicket, setShowTicket] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState({ show: false, msg: [] });

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const strips = [
    { title: "Fleje skid 1.60 cm", name: "strip_skid_160" },
    { title: "Fleje skid medio", name: "strip_skid_medium" },
    { title: "Fleje pza suelta", name: "strip_loose" },
    { title: "Vitafilm skid 1.60 cm", name: "vitafilm_skid_160" },
    { title: "Vitafilm skid medio", name: "vitafilm_skid_medium" },
    { title: "Vitafilm pza suelta", name: "vitafilm_loose" },
    { title: "Suministro Tarima Std", name: "pallet_supply_std" },
    { title: "Suministro Tarima Eur", name: "pallet_supply_eur" },
  ];

  const onSubmit = async (data) => {
    setLoading(true);
    const errorList = [];

    const entry = new Date(`${data.entry_date} ${data.entry_hour}`);
    const exit = new Date(`${data.exit_date} ${data.exit_hour}`);

    if (exit < entry) {
      errorList.push(
        "La fecha/hora de salida no puede ser menor a la de entrada"
      );
    }

    if (errorList.length > 0) {
      setErrorMsg({ show: true, msg: errorList });
      return;
    }

    const fullData = {
      exit_date: data.exit_date,
      exit_hour: data.exit_hour,
      entry_date: data.entry_date,
      entry_hour: data.entry_hour,
      weight: Number(data.weight),
      custom_value: Number(data.custom_value) || 0,
      weight_refri: Number(data.weight_refri) || 0,
      weight_conge: Number(data.weight_conge) || 0,
      un_dg: Number(data.un_dg) || 0,
      ice: data.ice ? 1 : 0,
      dg_exempt: data.dg_exempt ? 1 : 0,
      avi: Number(data.avi) || 0,
      hum: data.hum ? 1 : 0,
    };

    strips.forEach((s) => {
      fullData[s.name] = Number(data[s.name]) || 0;
    });

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_quote/getQuote`,
        fullData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        setTicketData(res.data.data);
        setLoading(false);
        setShowTicket(true);
        setErrorMsg({ show: false, msg: [] });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: error.response?.data?.message || "Error en la cotización",
        icon: "warning",
        iconColor: "#FCC732",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    const todayStr = $.datepicker.formatDate("yy-mm-dd", new Date());

    $("#entry_date").datepicker({
      dateFormat: "yy-mm-dd",
      defaultDate: new Date(),
      onSelect: function (selectedDate) {
        $("#exit_date").datepicker("option", "minDate", selectedDate);
        setValue("entry_date", selectedDate);
      },
    });

    $("#exit_date").datepicker({
      dateFormat: "yy-mm-dd",
      defaultDate: new Date(),
      minDate: new Date(),
      onSelect: function (selectedDate) {
        setValue("exit_date", selectedDate);
      },
    });

    $("#entry_date").val(todayStr);
    $("#exit_date").val(todayStr);

    setValue("entry_date", todayStr);
    setValue("exit_date", todayStr);
  }, []);

  return (
    <>
      <Helmet>
        <title>Horus | Cotizador</title>
      </Helmet>
      <ScrollToTop />
      <form className="container-fluid" onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-lg-12">
            <h2 className="page-header">Cotizador</h2>
          </div>
        </div>

        <div className="row">
          {/* Fecha entrada */}
          <div className="col-md-3 mb-3">
            <label className="bold">Fecha entrada *</label>
            <input
              type="text"
              className="form-control datepicker"
              id="entry_date"
              {...register("entry_date", {
                required: "Fecha de entrada es obligatoria",
              })}
            />
          </div>
          {/* Hora entrada * */}
          <div className="col-md-3 mb-3">
            <label className="bold">Hora entrada *</label>
            <input
              type="time"
              className="form-control inp_mani_hour only_numbers"
              id="entry_hour"
              maxLength={5}
              {...register("entry_hour", {
                required: "Hora de entrada es obligatoria",
              })}
            />
          </div>
          {/* Fecha salida * */}
          <div className="col-md-3 mb-3">
            <label className="bold">Fecha salida *</label>
            <input
              type="text"
              className="form-control datepicker"
              id="exit_date"
              {...register("exit_date", {
                required: "Fecha de salida es obligatoria",
              })}
            />
          </div>
          {/* Hora salida * */}
          <div className="col-md-3 mb-3">
            <label className="bold">Hora salida * </label>
            <input
              type="time"
              className="form-control inp_mani_hour only_numbers"
              id="exit_hour"
              maxLength={5}
              {...register("exit_hour", {
                required: "Hora de salida es obligatoria",
              })}
            />
          </div>
          {/* Peso de la carga * */}
          <div className="col-md-3 mb-3">
            <label className="bold">Peso de la carga *</label>
            <input
              type="number"
              className="form-control"
              id="weight"
              {...register("weight", {
                required: "Peso de la carga es obligatorio",
              })}
            />
          </div>
          {/* Peso refrigeración*/}
          <div className="col-md-3 mb-3">
            <label className="bold">Peso refrigeración</label>
            <input
              type="number"
              className="form-control"
              id="weight_refri"
              {...register("weight_refri")}
            />
          </div>
          {/* Peso congelación*/}
          <div className="col-md-3 mb-3">
            <label className="bold">Peso congelación</label>
            <input
              type="number"
              className="form-control"
              id="weight_conge"
              {...register("weight_conge")}
            />
          </div>
          {/* Valor aduana*/}
          <div className="col-md-3 mb-3">
            <label className="bold">Valor aduana</label>
            <input
              type="number"
              className="form-control"
              id="custom_value"
              {...register("custom_value")}
            />
          </div>
        </div>

        <div className="row">
          {/* UN (Merc. peligrosas) */}
          <div className="col-md-3 mb-3">
            <label className="bold">UN (Merc. peligrosas)</label>
            <input
              type="number"
              className="form-control"
              id="un_dg"
              min={0}
              {...register("un_dg")}
            />
            <small className="text-info">Cantidad total de UN en la guía</small>
          </div>

          {/* Contenedor de AVI */}
          <div className="col-md-3 mb-3">
            <label className="bold">Contenedor de AVI</label>
            <input
              type="number"
              className="form-control"
              id="avi"
              min={0}
              {...register("avi")}
            />
          </div>

          {/* ¿Hielo Seco? */}
          <div className="col-md-2 mb-3 d-flex flex-column">
            <label className="bold mb-1">¿Hielo Seco?</label>
            <input type="checkbox" id="ice" {...register("ice")} />
          </div>

          {/* ¿DG exentas? */}
          <div className="col-md-2 mb-3 d-flex flex-column">
            <label className="bold mb-1">¿DG exentas?</label>
            <input type="checkbox" id="dg_exempt" {...register("dg_exempt")} />
          </div>

          {/* ¿DG exentas? */}
          <div className="col-md-2 mb-3 d-flex flex-column">
            <label className="bold mb-1">¿Manejo RH?</label>
            <input type="checkbox" id="hum" {...register("hum")} />
          </div>
        </div>

        <div className="row justify-content-center mt-4 mb-4">
          <div className="col-md-offset-3 col-md-6 table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>
                    <small>Nombre</small>
                  </th>
                  <th>
                    <small>Cantidad</small>
                  </th>
                </tr>
              </thead>
              <tbody>
                {strips.map((strip) => (
                  <tr key={strip.name}>
                    <td className="text-center">
                      <small>{strip.title}</small>
                    </td>

                    <td className="text-center">
                      <input
                        className="form-control form-20px strip w100px d-block m-auto"
                        type="number"
                        min={0}
                        step={1}
                        id={strip.name}
                        {...register(strip.name)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="col-md-12">
            <p className="text-right">
              <FaSpinner
                className="loader-spiner-filter"
                style={loading ? {} : { display: "none" }}
              />
              <button
                className="btnn"
                type="submit"
                style={!loading ? {} : { display: "none" }}
              >
                Cotizar
              </button>
            </p>
          </div>
          <div className="col-md-12">
            {(Object.keys(errors).length > 0 || errorMsg.show) && (
              <p className="alert alert-danger">
                Favor de llenar los campos obligatorios para continuar:
                <ul className="mt-2">
                  {Object.values(errors).map((e, idx) => (
                    <li key={idx}>{e.message}</li>
                  ))}

                  {errorMsg.msg.map((e, idx) => (
                    <li key={idx}>{e}</li>
                  ))}
                </ul>
              </p>
            )}
          </div>
        </div>
      </form>

      <Ticket
        show={showTicket}
        onHide={() => setShowTicket(false)}
        data={ticketData}
      />
    </>
  );
};

export default Quote;
